module.exports = __webpack_public_path__ + "up_right_arrow.2f38da5d1d110b22bc3d6ab529127d33.svg";